import React from 'react';
import { Home, Layers, Grid, PenTool, Video, BoxIcon } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Homestaging',
    description: 'Leere Räume werden zu einladenden Wohnwelten – ohne Möbelverleih.',
    icon: Home
  }, {
    title: 'Fassaden',
    description: 'Außenansichten visualisieren, bevor der erste Stein gesetzt wird.',
    icon: BoxIcon
  }, {
    title: 'Varianten',
    description: 'Mehrere Designoptionen auf Knopfdruck – für fundierte Entscheidungen.',
    icon: Layers
  }, {
    title: 'Renovierung',
    description: 'Zeigen Sie das Potenzial von Bestandsimmobilien.',
    icon: PenTool
  }, {
    title: 'Grundriss',
    description: '2D-Pläne werden zu verständlichen 3D-Ansichten.',
    icon: Grid
  }, {
    title: 'Animation',
    description: 'Bewegte Bilder für Exposés und Präsentationen.',
    icon: Video
  }];
  return <section id="services" className="py-24 bg-[#0A0A0B]" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-159">
          <h2 className="text-3xl sm:text-4xl font-semibold text-white mb-6" data-id="element-160">
            Unsere Leistungen
          </h2>
          <p className="text-lg font-light text-zinc-400" data-id="element-161">
            Präzise Visualisierungslösungen für jeden Schritt Ihres
            Immobilienprojekts.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-162">
          {services.map(service => <div key={service.title} className="group glass-card p-8 rounded-2xl hover:bg-white/[0.06] transition-all duration-300" data-id="element-163">
              <div className="w-12 h-12 bg-blue-500/10 border border-blue-500/20 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-500/20 transition-colors duration-300" data-id="element-164">
                <service.icon className="w-6 h-6 text-blue-400" data-id="element-165" />
              </div>
              <h3 className="text-xl font-medium text-white mb-3" data-id="element-166">
                {service.title}
              </h3>
              <p className="font-light text-zinc-400 leading-relaxed" data-id="element-167">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}